import { call } from 'redux-saga/effects';
import {
	AmplitudeActionType,
	AmplitudeEventAction,
	AmplitudeInitializeAction
} from './actions';
import { combineAllWatchers, createWatcherSaga, SagaYieldType } from '@sonar-software/xuder';
import { initializeAmplitude, logAmplitudeEvent } from '../lib';

/* eslint-disable */
export function* requestAmplitudeEventSaga(action: AmplitudeEventAction) {
	/* eslint-enable */
	const { event } = action;

	yield call(logAmplitudeEvent, event);
}

export const watchRequestAmplitudeEventSaga = createWatcherSaga([
	{
		action: AmplitudeActionType.RequestEvent,
		actionHandler: requestAmplitudeEventSaga,
		type: SagaYieldType.Every
	}
]);

/* eslint-disable */
export function* requestAmplitudeInitializeSaga(action: AmplitudeInitializeAction) {
	/* eslint-enable */
	const { data } = action;

	yield call(initializeAmplitude, data);
}

export const watchRequestAmplitudeInitializeSaga = createWatcherSaga([
	{
		action: AmplitudeActionType.RequestInitialize,
		actionHandler: requestAmplitudeInitializeSaga,
		type: SagaYieldType.Every
	}
]);

export const amplitudeWatchers = combineAllWatchers([
	watchRequestAmplitudeEventSaga,
	watchRequestAmplitudeInitializeSaga
]);
